import React, { useState, useContext, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './MultisellerListCard.css'
import Timer from '../../Product/common/timer'
import Bidding from '../../Product/components/molecules/Bidding/BiddingItem'
import Biddingforwardandreverse from '../../Product/components/molecules/Bidding/biddingforwardandreverse'
import AddToCart from '../../utils/CommonFunctionality/Cart/AddToCart'
import Bidhistory from '../Bidhistory'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import ReadMoreReact from 'read-more-react'
import PaginationComponent from '../Pagination'
import AuthContext from '../../Product/context/auth/authContext'
import { currencyFormat } from '../../Product/common/components'
import FavouriteCheckbox from '../../Product/components/atoms/FavoriteCheckbox'
import { getFilePath } from '../../utils/commonFunctions'
import moment from 'moment'
import ReadMore from '../ReadMore'
import { Tooltip } from '@material-ui/core'
import MakeAnoffer from '../../Product/common/make_offer'
import CurrencyConverterFormat from '../../utils/CommonFunctionality/CurrencyConverter/CurrencyConverterFormat'
import { useMediaQuery } from 'react-responsive'
function TableView(props) {
    const [selectedHistory, setSelectedHistory] = useState({})
    const [lotDescription, setLotDescription] = useState([])
    let paragraph = '<p></p>'
    const openHistory = (property) => {
        setSelectedHistory(property)
    }
    const [showTooltip, setShowTooltip] = useState(false)
    const authContext = useContext(AuthContext)
    const { isAuthenticated, user } = authContext
    const [showDescription, setShowDescription] = useState(false)
    const [bidText, setBidText] = useState('')
    const isPrimeBidsTheme = document.querySelector('body').classList.contains('primeBids')
    /*eslint-disable*/
    const removeparagraphtag = (val) => {
        var data = ''
        if (val) {
            data = val.replace(/&#34;/g, '"')
            data = data.replace(/<p>/g, '')
            data = data.split('</p>').join('')
            return data
        } else {
            return data
        }
    }
    const isMobile = useMediaQuery({
        query: '(max-width: 600px)',
    })
    // const getBidText = (data) => {
    //     if (isAuthenticated && data.latestbid != null && user?.id != undefined) {
    //         if (data.auction) {
    //             if (
    //                 (data.highbid || data.latestbid_user == user?.id) &&
    //                 data.latestbid >= data.rprice
    //             ) {
    //                 if (data.market_status == 'open') {
    //                     return 'Winning'
    //                 } else if (data.market_status == 'sold') {
    //                     return 'Won'
    //                 }
    //             } else if ((!data.highbid || data.latestbid_user != user?.id) && data.cbidnot) {
    //                 if (data.market_status == 'open') {
    //                     return 'Outbid'
    //                 } else if (data.market_status == 'sold') {
    //                     return 'Lost'
    //                 }
    //             } else {
    //                 return ''
    //             }
    //         }
    //     }
    // }
    const getBidText = (data) => {
        if (
            isAuthenticated &&
            (data.latestbid_user != null || data.latestbid != null) &&
            user?.id != undefined
        ) {
            if (data.auction) {
                if (
                    (data.latestbid_user == user?.id || data.highbid) &&
                    data.wprice >= data.rprice
                ) {
                    if (data.market_status == 'open') {
                        return 'Winning'
                    } else if (data.market_status == 'sold') {
                        return 'Won'
                    }
                } else if (
                    data.latestbid_user != user?.id &&
                    (data.currentUserBidAmount || data.bid_or_not || data.cbidnot)
                ) {
                    if (data.market_status == 'open') {
                        return 'Outbid'
                    } else if (data.market_status == 'sold') {
                        return 'Lost'
                    }
                } else {
                    return ''
                }
            }
        } else {
            return ''
        }
    }
    const hawaiiTheme = global.storeConfigration?.bodyClass?.value === 'hawaii'
    useEffect(() => {
        if (props.lotData?.length) {
            setLotDescription(new Array(props.lotData?.length).fill(false))
        }
    }, [props.lotData])
    const handleLotDescription = (index) => {
        let temp = lotDescription
        temp[index] = !temp[index]
        setLotDescription([...temp])
    }
    return (
        <>
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>Image</th>
                        {global?.storeConfigration?.lot_sequence_order?.value == 1 ? (
                            <th>Lot #</th>
                        ) : (
                            <th>Lot Number</th>
                        )}
                        <th>Title</th>
                        <th>Description</th>
                        <th>Closing in</th>
                        <th>Current bid</th>
                        <th>No. of bids</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {props.lotData.map((item, index) => (
                        <React.Fragment key={index}>
                            <tr>
                                {/*eslint-disable*/}

                                <td className="clearfix sl-img-wrap" data-title="Image">
                                    <div className="position-relative" style={{ height: '100%' }}>
                                        <div className="buyTableAucTab lctnFavWrapper row d-flex align-items-center justify-content-between">
                                            {item.market_status == 'open' && (
                                                <>
                                                    {props.cardTheme == 'liquidationTwo' ||
                                                    global.storeDetails?.theme === 18 ? (
                                                        <div className="lctnTxtWrpr d-flex align-items-center justify-content-end">
                                                            <span className="material-icons">
                                                                location_on
                                                            </span>
                                                            <span className="location-class">
                                                                {localStorage.getItem(
                                                                    'globalLocation',
                                                                )
                                                                    ? localStorage.getItem(
                                                                          'globalLocation',
                                                                      )
                                                                    : ''}
                                                            </span>
                                                        </div>
                                                    ) : null}

                                                    <FavouriteCheckbox
                                                        watchlisted={
                                                            item.watchlistid ||
                                                            item.watchlisted ||
                                                            item.isFav
                                                        }
                                                        project_id={item.id}
                                                        from="card"
                                                        viewProduct={props.lotData}
                                                        setViewProduct={props.setSubLotData}
                                                        data={item}
                                                    />
                                                </>
                                            )}
                                        </div>
                                        <div className="tblImgWrpr">
                                            {global?.storeConfigration?.sold_status?.value ==
                                            '1' ? (
                                                <></>
                                            ) : (
                                                <>
                                                    {item.market_status === 'sold' && (
                                                        <div className="soldWrapper">
                                                            <p>SOLD</p>
                                                        </div>
                                                    )}
                                                    {item.market_status === 'closed' && (
                                                        <div className="soldWrapper">
                                                            <p className="unsolding">UNSOLD</p>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            {item.avatar_vc != '' ||
                                            item.avatar_vc != undefined ||
                                            item.avatar != '' ? (
                                                <LazyLoadImage
                                                    height="100%"
                                                    width="100%"
                                                    placeholderSrc="/assets/svg/imageLoading.svg"
                                                    effect="blur"
                                                    src={`${
                                                        item.content_head1 === '0' ||
                                                        item.store_id === 0
                                                            ? process.env.REACT_APP_BASE_URL +
                                                              'uploads/product/'
                                                            : process.env
                                                                  .REACT_APP_PRODUCT_IMAGE_URL
                                                    }${
                                                        global.storeConfigration?.image_compression
                                                            ?.value == 1
                                                            ? 'thumb_'
                                                            : ''
                                                    }${
                                                        (item?.lotImages &&
                                                            item?.lotImages[0]?.file_name) ||
                                                        item?.file_name ||
                                                        item?.avatar_vc ||
                                                        item?.avatar
                                                    }`}
                                                    alt=""
                                                    onError={(e) =>
                                                        (e.target.src = `${global?.storeDetails?.logoValue}`)
                                                    }
                                                    onClick={() => props.selectedPostion(item.id)}
                                                />
                                            ) : item.productImagesName != '' ? (
                                                <img
                                                    src={getFilePath(
                                                        item.productImagesName,
                                                        item.auctionlot_title,
                                                        true,
                                                    )}
                                                    alt=""
                                                    onError={(e) =>
                                                        (e.target.src = `${global?.storeDetails?.logoValue}`)
                                                    }
                                                    onClick={() => props.selectedPostion(item.id)}
                                                />
                                            ) : (
                                                <img
                                                    src={`${global?.storeDetails?.logoValue}`}
                                                    className="pro-img img-fluid"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </td>
                                {/* {console.log('ITEM-', item)} */}
                                {global?.storeConfigration?.lot_sequence_order?.value == 1 ? (
                                    <td
                                        className="clearfix responsiveView auctionLotLot tableTit"
                                        data-title="Lot#"
                                        onClick={() => props.selectedPostion(item.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {`${item.deed_document}`}
                                        {/* {item.lot_number || '-'} */}
                                    </td>
                                ) : (
                                    <td
                                        className="clearfix responsiveView auctionLotLot tableTit"
                                        data-title="Lot Number"
                                        onClick={() => props.selectedPostion(item.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {item?.lot_number !== '' ? item.lot_number : '-'}
                                    </td>
                                )}
                                <td
                                    className="clearfix responsiveView auctionLotTitle tableTit"
                                    data-title="Title"
                                    // dangerouslySetInnerHTML={{
                                    //     __html: item.title,
                                    // }}
                                >
                                    <ReadMore
                                        data={item.bundle_id > 0 ? item.bundle_name : item.title}
                                        limit={50}
                                        onClick={() => props.selectedPostion(item.id)}
                                    />
                                </td>
                                {/* <td
                                    className="clearfix responsiveView auctionLotId"
                                    data-title="Id"
                                >
                                    <ReadMore data={item.id} limit={50} />
                                </td> */}
                                <td
                                    className="clearfix responsiveView auctionLotTitle auctionDespn"
                                    data-title="Description"
                                >
                                    <>
                                        <ReadMore
                                            data={item.description}
                                            limit={50}
                                            onClick={() => props.selectedPostion(item.id)}
                                        />
                                        {/* <>
                                                {(item.description &&
                                                    item.description?.length < 150) ||
                                                lotDescription[index] ? (
                                                    <>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: item.description,
                                                            }}
                                                        ></div>
                                                        {item.description?.length > 150 && (
                                                            <span
                                                                className="cursorDecoy"
                                                                onClick={() =>
                                                                    handleLotDescription(index)
                                                                }
                                                            >
                                                                <b>
                                                                    <u>HIDE</u>
                                                                </b>
                                                            </span>
                                                        )}
                                                    </>
                                                ) : (
                                                    <>
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    item.description &&
                                                                    item.description.slice(0, 150) +
                                                                        '...',
                                                            }}
                                                        ></div>
                                                        <span
                                                            className="cursorDecoy"
                                                            onClick={() =>
                                                                handleLotDescription(index)
                                                            }
                                                        >
                                                            <b>
                                                                <u>READ MORE</u>
                                                            </b>
                                                        </span>
                                                    </>
                                                )}
                                            </> */}
                                    </>

                                    {/* <ReadMoreReact
                                        text={removeparagraphtag(item.description)}
                                        min={150}
                                        ideal={200}
                                        max={400}
                                        readMoreText={'READ MORE'}
                                    /> */}
                                </td>
                                <td
                                    className="clearfix responsiveView tableTimer"
                                    data-title="Closing In"
                                    onClick={() => props.selectedPostion(item.id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {item.auction != 1 && item.buynow == 1 ? (
                                        '-'
                                    ) : (
                                        <>
                                            {item.market_status != 'open' || item.productClosed ? (
                                                'Closed'
                                            ) : item.extend || item.agent_id == 1 ? (
                                                <span className="tmm">
                                                    <Timer
                                                        date_added={item.date_added}
                                                        date_closed={item.date_closed}
                                                        withText={1}
                                                        endText={'Ends in' + ':'}
                                                        startText={'Starts in' + ':'}
                                                        audio={props.audio}
                                                        viewProduct={props.viewProduct}
                                                        setViewProduct={props.setViewProduct}
                                                        product_id={item.id}
                                                        noGIF={props?.noGIF}
                                                    ></Timer>
                                                </span>
                                            ) : (
                                                <span>
                                                    <Timer
                                                        date_added={item.date_added}
                                                        date_closed={item.date_closed}
                                                        withText={1}
                                                        endText={'Ends in' + ':'}
                                                        startText={'Starts in' + ':'}
                                                        audio={props.audio}
                                                        product_id={item.id}
                                                        viewProduct={props.viewProduct}
                                                        setViewProduct={props.setViewProduct}
                                                        noGIF={props?.noGIF}
                                                    ></Timer>
                                                </span>
                                            )}
                                        </>
                                    )}
                                </td>
                                {/* <td>{`$${item.sprice}`}</td> */}
                                {hawaiiTheme && isMobile ? (
                                    <>
                                        {/* <td
                                            className="clearfix price-con responsiveView"
                                            data-title="Current Bid"
                                            onClick={() => props.selectedPostion(item.id)}
                                            style={{ cursor: 'pointer' }}
                                        > */}
                                        {/* {item.latestbid
                                        ? `US$ ${parseFloat(item.latestbid).toFixed(2)}`
                                        : 'N/A'} */}

                                        {/* {item.latestbid &&
                                            item.rprice &&
                                            parseInt(item.rprice) > 0 ? (
                                                parseFloat(item.latestbid) >=
                                                parseFloat(item.rprice) ? (
                                                    <span style={{ color: '#838383' }}>
                                                        (Reserve has been met)
                                                    </span>
                                                ) : (
                                                    <span style={{ color: '#8B0000' }}>
                                                        (Reserve has not been met yet)
                                                    </span>
                                                )
                                            ) : (
                                                ''
                                            )}
                                        </td> */}
                                        <td
                                            className="clearfix price-con w-100 responsiveView"
                                            data-title={`${
                                                item.market_status === 'sold'
                                                    ? 'Sold'
                                                    : item.nobids || item.bid_count
                                                    ? 'Current'
                                                    : item.auction !== 1 && item.buynow === 1
                                                    ? 'Buy now'
                                                    : 'Start'
                                            } Price`}
                                        >
                                            <span className="">
                                                {currencyFormat(
                                                    parseFloat(
                                                        item.auction != 1 && item.buynow == 1
                                                            ? item.bprice
                                                            : item.wprice,
                                                    ).toFixed(2),
                                                )}
                                            </span>
                                        </td>

                                        {global.storeConfigration?.show_condition?.value == 1 &&
                                        props.cardTheme != 'liquidationTwo' ? (
                                            <td
                                                className="clearfix price-con responsiveView"
                                                data-title="Condition"
                                            >
                                                <span className="conditionDet">
                                                    <ReadMore
                                                        data={
                                                            item.auctionnotes
                                                                ? item.auctionnotes
                                                                : '-'
                                                        }
                                                        limit={50}
                                                    />
                                                </span>
                                            </td>
                                        ) : null}

                                        {global.storeConfigration?.condition_with_color?.value ==
                                        1 ? (
                                            <td
                                                className="clearfix price-con responsiveView"
                                                data-title="Condition"
                                            >
                                                <span
                                                    className={`prcTxtVal ${
                                                        item.auctionnotes
                                                            ?.trim()
                                                            ?.toLowerCase()
                                                            ?.includes('new')
                                                            ? 'badge badge-success text-white'
                                                            : item.auctionnotes
                                                                  ?.trim()
                                                                  ?.toLowerCase()
                                                                  ?.includes('open box')
                                                            ? 'badge badge-primary text-white'
                                                            : item.auctionnotes
                                                                  ?.trim()
                                                                  ?.toLowerCase()
                                                                  ?.includes('damage')
                                                            ? 'badge badge-danger text-white'
                                                            : ''
                                                    }`}
                                                    title={
                                                        item.auctionnotes ? item.auctionnotes : '-'
                                                    }
                                                >
                                                    {item.auctionnotes ? item.auctionnotes : '-'}
                                                </span>
                                            </td>
                                        ) : null}
                                        {global.storeConfigration?.show_retailPrice?.value == 1 &&
                                        props.cardTheme === 'liquidation' ? (
                                            // <span className="d-block Pricecutr">
                                            <td
                                                className="clearfix price-con responsiveView"
                                                data-title="Retail Price"
                                            >
                                                {item.mprice ? (
                                                    <>
                                                        <span className="prcTxtVal">
                                                            {currencyFormat(
                                                                parseFloat(
                                                                    item.mprice || 0,
                                                                ).toFixed(2),
                                                                props.currencyType,
                                                            )}
                                                            <CurrencyConverterFormat
                                                                amount={item.mprice}
                                                            />
                                                        </span>
                                                    </>
                                                ) : (
                                                    <td
                                                        className="clearfix price-con responsiveView"
                                                        data-title="Retail Price"
                                                    >
                                                        <span className="prcTxtVal">-</span>
                                                    </td>
                                                )}
                                            </td>
                                        ) : null}
                                        {global?.storeConfigration?.need_transferable?.value ==
                                        1 ? (
                                            <td
                                                className="clearfix price-con responsiveView"
                                                data-title="Transferable"
                                            >
                                                {item.transferable ? (
                                                    <Tooltip
                                                        title={
                                                            item.transferable == 'Yes'
                                                                ? 'This item can be transfered to a different warehouse location for pickup.'
                                                                : item.transferable == 'No'
                                                                ? 'This item must be picked up from its original location.'
                                                                : ''
                                                        }
                                                        arrow
                                                        placement="top-start"
                                                        open={showTooltip}
                                                        onOpen={() => setShowTooltip(true)}
                                                        onClose={() => setShowTooltip(false)}
                                                        className="tooling"
                                                        style={{ marginLeft: '5px' }}
                                                    >
                                                        <span
                                                            onClick={() =>
                                                                setShowTooltip(!showTooltip)
                                                            }
                                                        >
                                                            i
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    ''
                                                )}
                                                <span className="conditionDet">
                                                    {item.transferable ? item.transferable : ' - '}
                                                </span>
                                            </td>
                                        ) : null}
                                    </>
                                ) : (
                                    <td
                                        className="clearfix price-con responsiveView"
                                        data-title="Current Bid"
                                        onClick={() => props.selectedPostion(item.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {/* {item.latestbid
                                        ? `US$ ${parseFloat(item.latestbid).toFixed(2)}`
                                        : 'N/A'} */}
                                        {global.storeConfigration?.show_condition?.value == 1 &&
                                        props.cardTheme != 'liquidationTwo' ? (
                                            <span className="d-block Pricecutr">
                                                Condition:
                                                <span className="conditionDet">
                                                    <ReadMore
                                                        data={
                                                            item.auctionnotes
                                                                ? item.auctionnotes
                                                                : '-'
                                                        }
                                                        limit={50}
                                                    />
                                                </span>
                                            </span>
                                        ) : null}

                                        {global.storeConfigration?.condition_with_color?.value ==
                                        1 ? (
                                            <span className="d-block Pricecutr">
                                                Condition:{' '}
                                                <span
                                                    className={`prcTxtVal ${
                                                        item.auctionnotes
                                                            ?.trim()
                                                            ?.toLowerCase()
                                                            ?.includes('new')
                                                            ? 'badge badge-success text-white'
                                                            : item.auctionnotes
                                                                  ?.trim()
                                                                  ?.toLowerCase()
                                                                  ?.includes('open box')
                                                            ? 'badge badge-primary text-white'
                                                            : item.auctionnotes
                                                                  ?.trim()
                                                                  ?.toLowerCase()
                                                                  ?.includes('damage')
                                                            ? 'badge badge-danger text-white'
                                                            : ''
                                                    }`}
                                                    title={
                                                        item.auctionnotes ? item.auctionnotes : '-'
                                                    }
                                                >
                                                    {item.auctionnotes ? item.auctionnotes : '-'}
                                                </span>
                                            </span>
                                        ) : null}
                                        <span className="d-block Pricecutr">
                                            {item.market_status == 'sold'
                                                ? 'Sold'
                                                : item.nobids || item.bid_count
                                                ? 'Current'
                                                : `${
                                                      item.auction != 1 && item.buynow == 1
                                                          ? 'Buy now'
                                                          : 'Start'
                                                  }`}{' '}
                                            Price:{' '}
                                            <span className="">
                                                {currencyFormat(
                                                    parseFloat(
                                                        item.auction != 1 && item.buynow == 1
                                                            ? item.bprice
                                                            : item.wprice,
                                                    ).toFixed(2),
                                                )}
                                            </span>
                                        </span>

                                        {item.latestbid &&
                                        item.rprice &&
                                        parseInt(item.rprice) > 0 ? (
                                            parseFloat(item.latestbid) >=
                                            parseFloat(item.rprice) ? (
                                                <span style={{ color: '#838383' }}>
                                                    (Reserve has been met)
                                                </span>
                                            ) : (
                                                <span style={{ color: '#8B0000' }}>
                                                    (Reserve has not been met yet)
                                                </span>
                                            )
                                        ) : (
                                            ''
                                        )}

                                        {global.storeConfigration?.show_retailPrice?.value == 1 &&
                                        props.cardTheme === 'liquidation' ? (
                                            <span className="d-block Pricecutr">
                                                {item.mprice ? (
                                                    <>
                                                        Retail Price:{' '}
                                                        <span className="prcTxtVal">
                                                            {currencyFormat(
                                                                parseFloat(
                                                                    item.mprice || 0,
                                                                ).toFixed(2),
                                                                props.currencyType,
                                                            )}
                                                            <CurrencyConverterFormat
                                                                amount={item.mprice}
                                                            />
                                                        </span>
                                                    </>
                                                ) : (
                                                    <>
                                                        Retail Price:{' '}
                                                        <span className="prcTxtVal">-</span>
                                                    </>
                                                )}
                                            </span>
                                        ) : null}

                                        {global?.storeConfigration?.need_transferable?.value ==
                                        1 ? (
                                            <span style={{ display: 'flex', whiteSpace: 'nowrap' }}>
                                                Transferable:
                                                {item.transferable ? (
                                                    <Tooltip
                                                        title={
                                                            item.transferable == 'Yes'
                                                                ? 'This item can be transfered to a different warehouse location for pickup.'
                                                                : item.transferable == 'No'
                                                                ? 'This item must be picked up from its original location.'
                                                                : ''
                                                        }
                                                        arrow
                                                        placement="top-start"
                                                        open={showTooltip}
                                                        onOpen={() => setShowTooltip(true)}
                                                        onClose={() => setShowTooltip(false)}
                                                        className="tooling"
                                                        style={{ marginLeft: '5px' }}
                                                    >
                                                        <span
                                                            onClick={() =>
                                                                setShowTooltip(!showTooltip)
                                                            }
                                                        >
                                                            i
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    ''
                                                )}
                                                <span className="conditionDet">
                                                    {item.transferable ? item.transferable : ' - '}
                                                </span>
                                            </span>
                                        ) : null}
                                    </td>
                                )}

                                <td
                                    className="clearfix responsiveView"
                                    id="presScroll"
                                    data-title="No. of Bids"
                                    // style={{ cursor: 'pointer' }}
                                >
                                    <a
                                        className="tb-link"
                                        href="#presScroll"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            if (!item.is_past && !isPrimeBidsTheme) {
                                                openHistory({
                                                    product_id: item.id,
                                                    end: item.date_closed,
                                                })
                                            }
                                        }}
                                    >
                                        {item.nobids}
                                    </a>
                                </td>
                                <td className="sl-pbids clearfix" data-title="Action">
                                    {item.market_status != 'open' ||
                                    item.productClosed ||
                                    (item.date_closed &&
                                        moment(item.date_closed).isValid() &&
                                        props.auctionTimer &&
                                        moment(props.auctionTimer).isValid() &&
                                        new Date(item.date_closed).getTime() -
                                            new Date(props.auctionTimer).getTime() <
                                            0) ? (
                                        <b>Auction Closed</b>
                                    ) : item?.user_id == user?.id ? (
                                        <p>You cannot bid your own product!</p>
                                    ) : global.pluginConfiguration?.make_an_offer?.enable &&
                                      item?.make_an_offer_io &&
                                      props.upcomming ? (
                                        <>
                                            <MakeAnoffer item={item} user={user} />
                                        </>
                                    ) : global.pluginConfiguration?.reverse_auction?.enable &&
                                      item.content_head5 == 1 ? (
                                        <>
                                            {new Date(item.date_added) > new Date() ? (
                                                <p>Wait until auction starts!</p>
                                            ) : (
                                                <Biddingforwardandreverse
                                                    theme="multiseller"
                                                    data={item}
                                                    hard="1"
                                                    is_registered={props.is_registered}
                                                    private_auction={props.private_auction}
                                                />
                                            )}
                                        </>
                                    ) : (
                                        <div className="d-flex flex-wrap subLotLine">
                                            {/* Temporary fix for hiding the hard bid. Need to add the ability to update it from the admin */}
                                            {global.storeDetails.site_id != 'AS0658' ? null : (
                                                <div className="row flex-nowrap slAct">
                                                    <div className="d-flex flex-wrap actCnt">
                                                        {item.auction && isAuthenticated ? (
                                                            <>
                                                                {global.storeConfigration?.hard_bid
                                                                    ?.value == '1' && (
                                                                    <Bidding
                                                                        data={item}
                                                                        hard="1"
                                                                        hideBid={1}
                                                                        audio={props.audio}
                                                                        searchView={true}
                                                                        // shortText="Submit Your Bid"
                                                                        enableNextBid={true}
                                                                        nextbidText={`Quick Bid ${
                                                                            item?.next_bid
                                                                                ? currencyFormat(
                                                                                      parseFloat(
                                                                                          item?.next_bid
                                                                                              ? item?.next_bid
                                                                                              : 0,
                                                                                      ).toFixed(2),
                                                                                  )
                                                                                : ''
                                                                        }`}
                                                                        removePopup={true}
                                                                    />
                                                                )}
                                                            </>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            )}

                                            {global.storeDetails.site_id != 'AS0658' &&
                                            global.storeDetails.site_id != 'AS0182' &&
                                            global.storeDetails.site_id != 'AS0201' ? (
                                                <div className="row flex-nowrap slAct">
                                                    <div className="d-flex flex-wrap actCnt 33">
                                                        {item.auction && isAuthenticated ? (
                                                            <>
                                                                {global.storeConfigration?.hard_bid
                                                                    ?.value == '1' && (
                                                                    <Bidding
                                                                        data={item}
                                                                        hard="1"
                                                                        audio={props.audio}
                                                                        hideReturnAssurance={true}
                                                                    />
                                                                )}
                                                            </>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            ) : null}

                                            {global.storeDetails.site_id == 'AS0658' ? (
                                                <div className="row flex-nowrap slAct">
                                                    {item.auction ? (
                                                        <>
                                                            {global.storeConfigration?.proxy_bid
                                                                ?.value == '1' && (
                                                                <Bidding
                                                                    data={item}
                                                                    hard="0"
                                                                    audio={props.audio}
                                                                    isBidAuctionBtn={true}
                                                                    shortText={
                                                                        <>
                                                                            <svg
                                                                                width="24"
                                                                                height="24"
                                                                                viewBox="0 0 24 24"
                                                                                className="mr-2"
                                                                                fill="#49454f"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                            >
                                                                                <path
                                                                                    d="M2.30031 20.2799L11.9003 10.6799L10.5003 9.25991L9.78031 9.9699C9.6878 10.0626 9.57791 10.1362 9.45694 10.1863C9.33596 10.2365 9.20628 10.2623 9.07531 10.2623C8.94434 10.2623 8.81466 10.2365 8.69369 10.1863C8.57271 10.1362 8.46283 10.0626 8.37031 9.9699L7.66031 9.25991C7.56761 9.16739 7.49406 9.0575 7.44388 8.93653C7.3937 8.81556 7.36787 8.68587 7.36787 8.55491C7.36787 8.42394 7.3937 8.29425 7.44388 8.17328C7.49406 8.05231 7.56761 7.94242 7.66031 7.84991L13.3203 2.18991C13.4128 2.0972 13.5227 2.02365 13.6437 1.97347C13.7647 1.92329 13.8943 1.89746 14.0253 1.89746C14.1563 1.89746 14.286 1.92329 14.4069 1.97347C14.5279 2.02365 14.6378 2.0972 14.7303 2.18991L15.4403 2.89991C15.8303 3.28991 15.8303 3.91991 15.4403 4.30991L14.7303 4.99991L16.1503 6.4299C16.2428 6.3372 16.3527 6.26365 16.4737 6.21347C16.5947 6.16329 16.7243 6.13746 16.8553 6.13746C16.9863 6.13746 17.116 6.16329 17.2369 6.21347C17.3579 6.26365 17.4678 6.3372 17.5603 6.4299C17.9503 6.8199 17.9503 7.45991 17.5603 7.84991L18.9703 9.25991L19.6803 8.54991C20.0703 8.15991 20.7103 8.15991 21.1003 8.54991L21.8003 9.25991C22.1903 9.64991 22.1903 10.2899 21.8003 10.6799L16.1503 16.3299C15.7603 16.7199 15.1203 16.7199 14.7303 16.3299L14.0303 15.6299C13.9354 15.5376 13.8599 15.4273 13.8083 15.3053C13.7568 15.1834 13.7302 15.0523 13.7302 14.9199C13.7302 14.7875 13.7568 14.6565 13.8083 14.5345C13.8599 14.4125 13.9354 14.3022 14.0303 14.2099L14.7303 13.4999L13.3203 12.0899L3.71031 21.6999C3.6178 21.7926 3.50791 21.8662 3.38694 21.9163C3.26596 21.9665 3.13628 21.9923 3.00531 21.9923C2.87434 21.9923 2.74466 21.9665 2.62369 21.9163C2.50271 21.8662 2.39283 21.7926 2.30031 21.6999C1.91031 21.3099 1.91031 20.6699 2.30031 20.2799ZM20.0003 18.9999C20.5307 18.9999 21.0395 19.2106 21.4145 19.5857C21.7896 19.9608 22.0003 20.4695 22.0003 20.9999V21.9999H12.0003V20.9999C12.0003 20.4695 12.211 19.9608 12.5861 19.5857C12.9612 19.2106 13.4699 18.9999 14.0003 18.9999H20.0003Z"
                                                                                    fill="#49454f"
                                                                                />
                                                                            </svg>
                                                                            MAX BID
                                                                        </>
                                                                    }
                                                                />
                                                            )}
                                                        </>
                                                    ) : null}
                                                </div>
                                            ) : (
                                                <div className="row flex-nowrap slAct bidDepotlistView">
                                                    {item.auction ? (
                                                        <>
                                                            {global.storeConfigration?.proxy_bid
                                                                ?.value == '1' && (
                                                                <Bidding
                                                                    data={item}
                                                                    hard="0"
                                                                    audio={props.audio}
                                                                />
                                                            )}
                                                        </>
                                                    ) : null}
                                                </div>
                                            )}

                                            <div className="row flex-nowrap slAct">
                                                {(parseInt(item.buynow) == 1 &&
                                                    parseInt(item.auction) == 0) ||
                                                (parseInt(item.wprice) <= parseInt(item.bprice) &&
                                                    parseInt(item.buynow) == 1 &&
                                                    parseInt(item.auction) == 1) ? (
                                                    <AddToCart
                                                        price={item.bprice}
                                                        id={item.id}
                                                        qty={item.qty}
                                                    />
                                                ) : null}
                                            </div>
                                            {getBidText(item) && (
                                                <p
                                                    className={`text-center ${`badgeStatus ${
                                                        item?.bidtopstatus?.includes('won')
                                                            ? 'Won'
                                                            : item?.bidtopstatus?.includes('lost')
                                                            ? 'Lost'
                                                            : item?.bidtopstatus?.includes(
                                                                  'winning',
                                                              )
                                                            ? 'Winning'
                                                            : item?.bidtopstatus?.includes('outbid')
                                                            ? 'Outbid'
                                                            : getBidText(item)
                                                    }`}`}
                                                >
                                                    {item?.bidtopstatus?.includes('won')
                                                        ? 'Won'
                                                        : item?.bidtopstatus?.includes('lost')
                                                        ? 'Lost'
                                                        : item?.bidtopstatus?.includes('winning')
                                                        ? 'Winning'
                                                        : item?.bidtopstatus?.includes('outbid')
                                                        ? 'Outbid'
                                                        : getBidText(item)}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </td>
                            </tr>
                            {props?.mobileAds &&
                            props?.isMobile &&
                            (index + 1) % props?.mobileAdsFrequency === 0 ? (
                                <tr>{props?.mobileAds}</tr>
                            ) : (
                                ''
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>

            {/* <PaginationComponent
                onPageChange={(pageNumber) => {
                    document.getElementById('sublot').scrollIntoView()
                    props.setSubLotSearch({ ...props.subLotSearch, page: pageNumber })
                }}
                totalProductCount={props.totalProductCount}
                currentPage={props.currentPage}
                resultToShow={props.resultToShow}
            /> */}
            <Bidhistory
                classNames="bidHstryModal"
                open={Object.keys(selectedHistory).length !== 0}
                value={selectedHistory}
                serverTime={props.serverTimeSocket}
                handleClose={() => openHistory({})}
            />
        </>
    )
}

export default TableView
